(function () {
  function initFaq(scope) {
    scope.querySelectorAll('[data-sse-faq]').forEach(function (faq) {
      if (faq.dataset.ready === 'true') return;
      faq.dataset.ready = 'true';
      var accordion = faq.dataset.accordion !== 'false';
      faq.querySelectorAll('[data-sse-faq-item]').forEach(function (item) {
        var button = item.querySelector('[data-sse-faq-button]');
        var panel = item.querySelector('[data-sse-faq-panel]');
        if (!button || !panel) return;
        button.addEventListener('click', function () {
          var opening = !item.classList.contains('is-open');
          if (accordion && opening) {
            faq.querySelectorAll('[data-sse-faq-item].is-open').forEach(function (other) {
              if (other === item) return;
              other.classList.remove('is-open');
              other.querySelector('[data-sse-faq-button]')?.setAttribute('aria-expanded', 'false');
            });
          }
          item.classList.toggle('is-open', opening);
          button.setAttribute('aria-expanded', String(opening));
        });
      });
    });
  }
  function init(scope) { initFaq(scope); }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
